var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 6.02V9.84C9.75 10.0522 9.66572 10.2557 9.51569 10.4057C9.36566 10.5557 9.16219 10.64 8.95001 10.64H1.31C1.2041 10.6413 1.09901 10.6216 1.00079 10.582C0.902576 10.5424 0.813203 10.4837 0.737854 10.4093C0.662505 10.3348 0.602656 10.2462 0.561829 10.1485C0.521001 10.0508 0.499992 9.9459 0.5 9.84V2.18C0.499992 2.0741 0.521001 1.96924 0.561829 1.87152C0.602656 1.7738 0.662505 1.68517 0.737854 1.61075C0.813203 1.53633 0.902576 1.47761 1.00079 1.438C1.09901 1.39839 1.2041 1.37867 1.31 1.38H5.13",
    stroke: "#BFBFBF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98999 0.5H10.63",
    stroke: "#BFBFBF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.63 3.14V0.5",
    stroke: "#BFBFBF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.79004 5.35L10.63 0.5",
    stroke: "#BFBFBF",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_738"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.13,
    height: 11.13,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareWhite);
export default __webpack_public_path__ + "static/media/share_white.14914f5a0a5f28178bfc35afa4695cef.svg";
export { ForwardRef as ReactComponent };